import * as log from 'loglevel';
import * as _ from 'lodash';
import 'pixi';
import "phaser";
import {preloadGameAssets} from "./preload/Preload";
import {updateGame} from "./update/Update";
import {createPlayer, resetPlayer} from "./sprites/player/Player";
import {setScaling, scaleGameToWindow} from "./scaling/Scaling";
import {createLevel, levelSprites, levelGroup, resetLevel} from "./level/Level";
import {addInteraction} from "./input/Interaction";
import {render} from "./render/Render";
import {resetCountdownTimer} from './timer/GameTimer';
import {addSounds} from './audio/AudioManager';
import {addStageTimerListeners} from './level/stages/StageManager';
import {createParticles} from './particles/ParticleManager';
import {registerUiSfx, playUiVoiceover} from '../audio/voiceovers/VoiceOverManager';
import {showSecondaryScreen} from '../screens/ScreenManager';
import {resetSortingGame} from '../screens/main-menu/difficulty-select/DifficultySelectScreen';
import {obstacleSprites} from './level/ground/Obstacles';
import {recyclingPickupSprites} from './level/platforms/RecyclingPickups';
import {powerUpSprites} from './level/power-ups/PowerUps';

export var game: Phaser.Game;

/**
 * bootstrap the game, doing any one-time setup we need
 * @returns {Phaser.Game}
 */
export function bootstrapGame() : Phaser.Game
{
    var gameState: any;

    //  set game options

    gameState =
    {
        preload: () => preloadGameAssets(),
        create: () => createGame(),
        update: () => updateGame(),
        render: () => onRender()
    };

    //PreloadScene.prototype.fileComplete = function
    //(progress, cacheKey, success, totalLoaded, totalFiles) {    this.progress.text = progress+"%";

    //  create a new Phaser game object

    game = new Phaser.Game(960, 640, Phaser.CANVAS, 'pp-gameplay__canvas', gameState);

    //  return the new game
    
    return game;
}


function onRender()
{
    //var rect = new Phaser.Rectangle( 100, 100, 100, 100 ) ;
    //var circle = new Phaser.Circle( 280, 150, 100 ) ;
    //var point = new Phaser.Point( 100, 280 ) ;
    //
    //_.forEach(recyclingPickupSprites, sprite =>
    //{
    //    //game.debug.geom( new Phaser.Rectangle( sprite.body.x,  sprite.body.y,  sprite.body.width,  sprite.body.height), 'rgba(255,0,0,1)' ) ;
    //    game.debug.text(sprite.x + '/' + sprite.y, sprite.body.x,  sprite.body.y) ;
    //})
    //
    //_.forEach(obstacleSprites, sprite =>
    //{
    //    game.debug.geom( new Phaser.Rectangle( sprite.body.x,  sprite.body.y,  sprite.body.width,  sprite.body.height), 'rgba(255,0,0,1)' ) ;
    //})
    //
    //_.forEach(powerUpSprites, sprite =>
    //{
    //    //game.debug.geom( new Phaser.Rectangle( sprite.body.x,  sprite.body.y,  sprite.body.width,  sprite.body.height), 'rgba(255,0,0,1)' ) ;
    //    game.debug.text(sprite.x + '/' + sprite.y, sprite.body.x,  sprite.body.y) ;
    //})


}




/**
 * set up the basic game structure
 */
function createGame()
{
    //  set up the physics engine and basic physics props

    game.physics.startSystem(Phaser.Physics.ARCADE);
    game.physics.arcade.gravity.y = 0;

    //  enable this to allow game to play while paused

    //TODO  turn this back on

    game.stage.disableVisibilityChange = true;

    //  set up audio

    addSounds();
    registerUiSfx();


    //  set game scaling properties

    setScaling();

    //  add game interaction

    addInteraction();

    addStageTimerListeners();

    //  create the level

    createLevel();

    //  create particle effects

    createParticles();

    //  create the player sprite

    createPlayer();

    //  pause the game until we're ready to start

    game.paused = true;
    game.sound.mute = false;

    //playUiVoiceover('main-menu--recycling-adventure', 3000);
    //playUiVoiceover('main-menu--recycling-adventure', 5000);
}


/**
 * start the game
 */
export function startGame()
{
    setTimeout(() =>
    {
        //  start playing the game

        game.paused = false;

        //  set the game scaling

        scaleGameToWindow();

        //  make the ground cover the width of the screen

        resetLevel();
        resetSortingGame();

        //  reset countdown and start the clock

        resetCountdownTimer();
    }, 50);
}


/**
 * reset the game to its starting state
 */
export function resetGame()
{
    //  pause the game

    game.paused = true;

    //  reset all game components

    resetSortingGame();
    resetLevel();
    resetPlayer();
}


// WEBPACK FOOTER //
// ./src/ts/game/GameCore.ts